<!--
 * @Description: 
 * @Date: 2021-02-04 20:34:14
-->
<template>
  <externalTitlePopup title="请填写领奖信息" @close="close">
    <div class="receive-info">
      <ul>
        <li>
          <p>收件人：</p>
          <input
            v-model="form.name"
            :maxlength="20"
            type="text"
            placeholder="请输入收件人姓名"
          />
        </li>
        <li>
          <p>收件电话：</p>
          <input
            v-model="form.phone"
            :maxlength="20"
            type="text"
            placeholder="请输入收件人联系方式"
          />
        </li>
        <li>
          <p>收货地址：</p>
          <input
            v-model="form.address"
            type="text"
            placeholder="请输入收货地址"
          />
        </li>
      </ul>
      <van-button
        color="linear-gradient(182deg, #5CC4FF, #004EEE)"
        class="receive-info__btn"
        type="primary"
        block
        :loading="loading"
        @click="save"
      >
        提交
      </van-button>
    </div>
  </externalTitlePopup>
</template>

<script>
import externalTitlePopup from '@/components/Popup/externalTitlePopup';
import { saveraffleWinnerInfo } from '@/api/course';

export default {
  name: 'LivingCoverReceiveInfo',
  inject: ['livingStore'],
  data() {
    return {
      form: {
        courseId: '',
        raffleId: '',
        userId: '',
        phone: '',
        name: '',
        address: '',
        prizeId: '',
        prizeName: ''
      },
      loading: false
    };
  },
  components: {
    externalTitlePopup
  },
  watch: {},
  computed: {
    userId() {
      return this.$store.state.user.info.id;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async save() {
      let {
        courseId,
        raffleId,
        prizeName,
        id: prizeId
      } = this.livingStore.drawResult;
      Object.assign(this.form, {
        courseId,
        raffleId,
        prizeName,
        prizeId,
        userId: this.userId
      });
      let values = Object.values(this.form);
      if (values.includes('')) {
        return false;
      }
      this.loading = true;
      try {
        await saveraffleWinnerInfo(this.form);
        this.$emit('done');
      } catch (e) {}
      this.loading = false;
    }
  },
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
.receive-info {
  padding: 0.61rem;
  ul {
    margin-bottom: 0.75rem;
    li {
      margin-bottom: 0.4rem;
      display: flex;
      align-items: center;
      &:last-child {
        margin-bottom: 0;
      }
      p {
        width: 1.7rem;
        font-size: 0.32rem;
        font-weight: 400;
        color: #666666;
        text-align: left;
        margin-right: 0.2rem;
      }
      input {
        background: #f3f3f3;
        border: 0.03rem solid #d2d2d2;
        width: 4.45rem;
        height: 0.83rem;
        padding: 0 0.1rem;
        &::placeholder {
          color: #c2c2c2;
        }
      }
    }
  }
  &__btns {
  }
  &__btn {
    border-radius: 0.16rem;
    width: 2.4rem;
    height: 0.9rem;
    margin: 0 auto;
  }
}
</style>
